var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Input, InputAdornment, Tooltip, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/pro-regular-svg-icons/faPen";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { combineSxProps, commonTooltipProps, useIsEllipsisActive } from "../../Utils";
const ENTER = "Enter";
const ESCAPE = "Escape";
const EMPTY_STRING = "";
export const InlineTextField = (_a) => {
    var { initialValue, onConfirm, getErrorMessage } = _a, inputProps = __rest(_a, ["initialValue", "onConfirm", "getErrorMessage"]);
    const [value, setValue] = useState(initialValue !== null && initialValue !== void 0 ? initialValue : EMPTY_STRING);
    const inputRef = useRef(null);
    const lastUpdatedValue = useRef(value);
    const isEscClicked = useRef(false);
    const isEllipsisActive = useIsEllipsisActive(inputRef);
    const errorMessage = getErrorMessage ? getErrorMessage(value) : EMPTY_STRING;
    const handleOnKeyDown = (e) => {
        isEscClicked.current = e.key === ESCAPE && !e.ctrlKey && !e.metaKey && !e.altKey;
        if (e.key === ENTER || e.key === ESCAPE)
            e.currentTarget.blur();
    };
    const handleOnBlur = (e) => {
        const isEscPressed = isEscClicked.current;
        isEscClicked.current = false;
        if (isEscPressed || errorMessage)
            return setValue(lastUpdatedValue.current);
        lastUpdatedValue.current = e.currentTarget.value;
        onConfirm(e.currentTarget.value);
    };
    return (_jsx(Tooltip, Object.assign({ title: isEllipsisActive ? value : "" }, commonTooltipProps, { children: _jsx(Input, Object.assign({ inputRef: inputRef, value: value, onChange: (e) => setValue(e.currentTarget.value), onKeyDown: handleOnKeyDown, onBlur: handleOnBlur, error: !!errorMessage, sx: combineSxProps(inputSx, inputProps.sx), disableUnderline: true, endAdornment: (_jsx(InputAdornment, { position: "end", sx: inputAdornmentSx, children: _jsx(Tooltip, Object.assign({ title: !isEllipsisActive && (errorMessage || "Edit") }, commonTooltipProps, { children: errorMessage ? _jsx(FontAwesomeIcon, { icon: faExclamationTriangle, style: { width: 24 } }) : (_jsx(IconButton, { size: "small", color: "primary", sx: editButtonSxProps, onClick: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, children: _jsx(FontAwesomeIcon, { icon: faPen }) })) })) })) }, inputProps)) })));
};
const inputSx = {
    backgroundColor: "transparent",
    caretColor: (theme) => theme.palette.primary.main,
    "&:not(.Mui-error) .MuiInputAdornment-root": {
        visibility: "hidden"
    },
    "&.Mui-disabled": {
        "&::before": {
            borderBottomWidth: 0
        }
    },
    "&:not(.Mui-disabled)": {
        "&:hover .MuiInputAdornment-root": {
            visibility: "visible"
        },
        "&:hover": {
            borderBottom: (theme) => "1px solid #8BA2FF"
        },
        "&.Mui-focused": {
            borderBottom: (theme) => "1px solid #0053E5"
        },
        "&.Mui-focused .MuiInputAdornment-root": {
            visibility: "hidden"
        }
    },
    "&.Mui-error": {
        caretColor: (theme) => theme.palette.error.main,
        "& svg": {
            color: (theme) => theme.palette.error.main
        },
        "&.Mui-focused .MuiInputAdornment-root": {
            visibility: "visible"
        },
        "&.Mui-focused": {
            borderBottom: (theme) => `1px solid ${theme.palette.error.main}`
        }
    },
    "& .MuiInput-input": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        paddingRight: "0px"
    }
};
const inputAdornmentSx = {
    marginLeft: "0px"
};
const editButtonSxProps = {
    "&:not([disabled]):not(:hover)": {
        color: "action.active"
    }
};
//# sourceMappingURL=InlineTextField.js.map